export enum InvestigationAttestationCapacity {
	Investigator = "INVESTIGATOR",
	Respondent = "RESPONDENT",
}
